/*
  Kachel-Auswahl fuer zusammengesetzte Variantenwerte.

  Der Theme-eigene Waehler bleibt im Seitenquelltext und macht weiterhin
  die ganze Arbeit: Preis, Verfuegbarkeit, Bilder, Warenkorb und die
  Staffelpreistabelle der Wholesale-App haengen daran. Dieses Skript setzt
  dort nur den passenden Wert und meldet die Aenderung.

  Ablauf beim Klick:
  1. Die aktuelle Auswahl wird Stelle fuer Stelle gelesen.
  2. Die angeklickte Stelle wird ersetzt.
  3. Gibt es diese Kombination nicht, wird der naechstbeste Wert gesucht,
     der die angeklickte Stelle enthaelt. Sonst liefe der Klick ins Leere.
  4. Der Wert wird im Theme-Waehler gesetzt und ein change-Ereignis
     ausgeloest.
*/
(function () {
  function init(wrapper) {
    if (wrapper.dataset.hssBereit === '1') return;
    wrapper.dataset.hssBereit = '1';

    var trenner = wrapper.dataset.separator || '/';
    var sektion = wrapper.dataset.section;

    // Zwei Faelle. Bei den Baendern steckt alles in EINEM Variantenwert
    // ("Grau / 10cm Breite / 5m Laenge"), der zerlegt werden muss. Bei der
    // EasyStick-Dachbahn gibt es wirklich zwei Optionen, dann steuert jede
    // Gruppe genau eine Auswahlliste des Themes.
    var echteOptionen = wrapper.dataset.hssModus === 'optionen';
    // Der Theme-Waehler wird bei jedem Variantenwechsel neu aufgebaut.
    // Deshalb NICHT zwischenspeichern, sondern jedes Mal frisch suchen -
    // sonst schreibt man in ein Element, das nicht mehr in der Seite haengt.
    function holWaehler() {
      return document.getElementById('variant-selects-' + sektion);
    }
    if (!holWaehler()) return;

    function alleWerte() {
      var select = holWaehler().querySelector('select');
      if (select) {
        return Array.prototype.map.call(select.options, function (o) {
          return { text: o.value, verfuegbar: !o.classList.contains('disabled') };
        });
      }
      return Array.prototype.map.call(holWaehler().querySelectorAll('input[type="radio"]'), function (i) {
        return { text: i.value, verfuegbar: !i.classList.contains('disabled') };
      });
    }

    function aktuellerWert() {
      var select = holWaehler().querySelector('select');
      if (select) return select.value;
      var an = holWaehler().querySelector('input[type="radio"]:checked');
      return an ? an.value : '';
    }

    function setzen(wert) {
      var select = holWaehler().querySelector('select');
      if (select) {
        select.value = wert;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        return true;
      }
      var treffer = Array.prototype.find.call(holWaehler().querySelectorAll('input[type="radio"]'), function (i) {
        return i.value === wert;
      });
      if (treffer) {
        treffer.checked = true;
        treffer.dispatchEvent(new Event('change', { bubbles: true }));
        return true;
      }
      return false;
    }

    function teile(wert) {
      return wert.split(trenner).map(function (t) {
        return t.trim();
      });
    }

    function passendenWertFinden(index, neuerTeil) {
      var jetzt = teile(aktuellerWert());
      var werte = alleWerte();

      // 1. Versuch: nur die angeklickte Stelle tauschen
      var wunsch = jetzt.slice();
      wunsch[index] = neuerTeil;
      var genau = werte.find(function (w) {
        var t = teile(w.text);
        return t.length === wunsch.length && t.every(function (x, i) { return x === wunsch[i]; });
      });
      if (genau) return genau.text;

      // 2. Versuch: der Wert, der die angeklickte Stelle enthaelt und
      //    sonst moeglichst viel mit der bisherigen Auswahl gemeinsam hat
      var beste = null;
      var bestePunkte = -1;
      werte.forEach(function (w) {
        var t = teile(w.text);
        if (t[index] !== neuerTeil) return;
        var punkte = 0;
        t.forEach(function (x, i) { if (i !== index && x === jetzt[i]) punkte++; });
        if (w.verfuegbar) punkte += 0.5;
        if (punkte > bestePunkte) { bestePunkte = punkte; beste = w.text; }
      });
      return beste;
    }

    function kachelnAktualisieren() {
      var jetzt = teile(aktuellerWert());
      wrapper.querySelectorAll('.hss-tiles__tile').forEach(function (k) {
        var idx = parseInt(k.dataset.hssIndex, 10);
        var an = jetzt[idx] === k.dataset.hssValue;
        k.classList.toggle('hss-tiles__tile--aktiv', an);
        k.setAttribute('aria-pressed', an ? 'true' : 'false');
      });
    }

    // --- Fall zwei: echte Optionen, je Gruppe eine eigene Auswahlliste ---
    function listeVon(index) {
      var w = holWaehler();
      if (!w) return null;
      return w.querySelector('#Option-' + sektion + '-' + index)
        || w.querySelectorAll('select')[index]
        || null;
    }

    function optionenSetzen(index, wert) {
      var liste = listeVon(index);
      if (!liste) return false;
      liste.value = wert;
      liste.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }

    function optionenAktualisieren() {
      wrapper.querySelectorAll('.hss-tiles__group').forEach(function (gruppe) {
        var idx = parseInt(gruppe.dataset.hssGroup, 10);
        var liste = listeVon(idx);
        if (!liste) return;
        // Welche Werte gibt es zur aktuellen Auswahl ueberhaupt noch?
        var gesperrt = {};
        Array.prototype.forEach.call(liste.options, function (o) {
          gesperrt[o.value] = o.classList.contains('disabled') || o.disabled;
        });
        gruppe.querySelectorAll('.hss-tiles__tile').forEach(function (k) {
          var an = liste.value === k.dataset.hssValue;
          k.classList.toggle('hss-tiles__tile--aktiv', an);
          k.setAttribute('aria-pressed', an ? 'true' : 'false');
          k.classList.toggle('hss-tiles__tile--weg', gesperrt[k.dataset.hssValue] === true);
        });
      });
    }

    wrapper.addEventListener('click', function (e) {
      var kachel = e.target.closest('.hss-tiles__tile');
      if (!kachel) return;
      e.preventDefault();
      var index = parseInt(kachel.dataset.hssIndex, 10);

      if (echteOptionen) {
        if (optionenSetzen(index, kachel.dataset.hssValue)) {
          setTimeout(optionenAktualisieren, 60);
        }
        return;
      }

      var ziel = passendenWertFinden(index, kachel.dataset.hssValue);
      if (ziel && setzen(ziel)) {
        // Der Theme-Waehler tauscht seinen Inhalt beim Wechsel aus,
        // deshalb erst danach nachziehen.
        setTimeout(kachelnAktualisieren, 60);
      }
    });

    var nachziehen = echteOptionen ? optionenAktualisieren : kachelnAktualisieren;

    // Wenn der Wert an anderer Stelle geaendert wird, ziehen die Kacheln nach.
    document.addEventListener('change', function () {
      setTimeout(nachziehen, 60);
    });

    nachziehen();
  }

  function start() {
    document.querySelectorAll('[data-hss-tiles]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // Nach dem Nachladen von Abschnitten (Theme-Editor, Varianten-Wechsel)
  document.addEventListener('shopify:section:load', start);
})();
